import React, { useState } from 'react';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import { BaseCellRendererProps } from '../Common/CellRendererProps';

export const DateCellRenderer: React.FC<BaseCellRendererProps> = (props) => {
  const [value, setValue] = useState<string>(
    props.value ? dayjs(props.value).format('DD/MM/YYYY') : ''
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    props.node.setDataValue(props.column.colId, newValue);
  };

  const handleBlur = () => {
    if (props.context?.onCellUpdate) {
      props.context.onCellUpdate(props.data, props.column.colId, value);
    }
  };

  return (
    <TextField
      size="small"
      type="date"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      variant="outlined"
      fullWidth
      InputLabelProps={{ shrink: true }}
    />
  );
};